'use client';

var styles = {"optionsContainer":"MobileSort-module_optionsContainer__39USo","sortingHighLight":"MobileSort-module_sortingHighLight__XUlQA","line":"MobileSort-module_line__1qyq1","svgAnimation":"MobileSort-module_svgAnimation__18Ob9","optionItem":"MobileSort-module_optionItem__3cSZO","selected":"MobileSort-module_selected__1yQ4j","icon":"MobileSort-module_icon__2w57i"};

export { styles as default };
//# sourceMappingURL=MobileSort.module.css.js.map
